<template>
    <v-app style="background-color:#ecf0f1">
        <v-navigation-drawer v-model="drawer" floating right app width="210">
            <v-list class="myNav">
                <v-list-item class="mx-auto text-center mb-8 mr-1"
                    style="display:block; background-image: url(/blob.svg)">
                    <v-btn class="mx-auto mt-4" style="border-radius: 14px;" color="#02c9b7" depressed elevation="0" fab
                        rounded>
                        <!--<img style="width: 48px; border-radius: 19px;" />-->
                        <span class="white--text">{{userName[0]}}</span>
                    </v-btn>
                    <h4 class="font-bold mt-2 mb-1">سلام {{userName}}</h4>
                    <v-btn @click="LogOut" class="" x-small rounded text color="secondary" outlined>
                        <iconly name="logout" size="12" class="ml-2" type="light" color="orange" /> خروج</v-btn>
                </v-list-item>
                <v-list-item exact class="" v-for="(item , i) in navItem" :key="i" color="primary"
                    :to="{name: item.url}">
                    <h5>{{ item.text }}</h5>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
        <v-app-bar elevation="0" color="transparent" app>
            <v-row>
                <v-col class="d-flex">
                    <v-btn @click="drawer = !drawer" class="ml-3" small icon>
                        <iconly name="morecircle" type="light" color="#02c9b7" />
                    </v-btn>
                    <h3 class="font-bold">{{$route.meta.title}}</h3>
                </v-col>
                <v-col class="d-flex" style="justify-content:flex-end">
                    <v-btn depressed small color="white">
                        <iconly size="20" name="plus" type="light" color="black" />
                    </v-btn>
                    <v-btn class="mr-2" depressed small color="white">
                        <iconly size="20" name="setting" type="light" color="black" />
                    </v-btn>
                    <v-btn class="mr-2" depressed small color="white">
                        <iconly size="20" name="notification" type="light" color="orange" />
                    </v-btn>
                </v-col>
            </v-row>
        </v-app-bar>
        <v-main>
            <v-container fluid>
                <router-view></router-view>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
    export default {
        data() {
            return {
                drawer: true,
                navItem: [{
                        text: 'داشبورد',
                        icon: '',
                        url: 'Dashboard',
                    },
                    {
                        text: 'دسته بندی ها',
                        icon: '',
                        url: 'list_category',
                    },
                    //  {
                    //     text: 'اسلایدر',
                    //     icon: '',
                    //     url: 'list_slider',
                    // },
                    // {
                    //     text: 'محصولات',
                    //     icon: '',
                    //     url: 'list_product',
                    // },
                    {
                        text: 'وبلاگ',
                        icon: '',
                        url: 'list_post',
                    },
                    {
                        text: 'مستند',
                        icon: '',
                        url: 'list_cook',
                    },
                ],
                userName : '',
            }
        },
        methods: {
            LogOut() {
                localStorage.removeItem('Token');
                localStorage.removeItem('UserName');
                localStorage.removeItem('UserId');
                this.$router.push('/login');
            },
        },
        created(){
            this.userName = localStorage.getItem('userName')
        }
    }
</script>

<style>
    .myNav .v-list-item--active {
        background-color: #feb039;
        color: white !important;
        box-shadow: 0 0 10px 1px #feb039;
        margin-right: 15px;
        margin-left: 15px;
        border-radius: 15px;
        justify-content: center;
        
    }

    .myNav .v-list-item {
        margin-right: 15px;
        margin-left: 15px;
        border-radius: 15px;
        justify-content: center;
        
    }

    .v-card {
        border-radius: 10px !important;
    }
</style>
